<template>
    <main class="main__sc__analysis__wrapper">

        <section class="work__packet__starter">

            <div class="work__packet__content__box">
                <h3 class="title">Work Packet</h3>
                <h6 class="sub__title">Learner: {{ learner?.firstname }} {{ learner?.lastname }}</h6>
                <div class="short__description">
                    <p>This packet is designed to support learners in developing their early echoic skills,
                        which are essential for language acquisition and verbal behavior. Through a structured and
                        systematic approach,
                        the EESA Program Planner and Protocol aim to assess, enhance, and track the progress of these
                        skills, providing a
                        solid foundation for further language development.
                    </p>
                </div>

                <div class="button__box__wrapper" v-if="!isMobile">
                    <div class="start__btn">
                        <a href="javascript:void(0)" @click="start">Start</a>
                    </div>
                </div>
            </div>
            <div class="assessment__list__box__wrapper">
                <ul>
                    <template v-for="(assessment) in assessments" :key="assessment.id">
                        <li class="workpacketSelectAssessment"
                            :class="{ active: selectedAssessmentId === assessment.id }"
                            @click="selectedAssessmentId = assessment.id">
                            <a href="javascript:void(0)">Assessment {{ assessment?.serialno }} ({{
                                formatDate(assessment.created_at) }})</a>
                        </li>
                    </template>
                </ul>

                <div class="button__box__wrapper" v-if="isMobile" style="padding: 15px 0; display: flex;justify-content: center;background: #eee;margin-right: -15px;margin-left: -15px;margin-bottom: -20px;border-radius: 0 0 15px 15px;">
                    <div class="start__btn">
                        <a href="javascript:void(0)" @click="start">Start</a>
                    </div>
                </div>
            </div>
        </section>
    </main>

</template>
<script setup>
import api from '@/services/axios';
import { handleError } from '@/utils/handleError';
import { useLoaderStore } from '@/stores/loader';
import { ref, onMounted, watch, computed, onUnmounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { formatDate } from '@/utils/format-helpers';

const router = useRouter();
const route = useRoute();
const organizationId = ref(Number(route.params.organization ?? 0));
const learnerId = ref(Number(route.params.learner ?? 0));

const loader = useLoaderStore();

// State
const learner = ref(null);
const assessments = ref(null);
const page = ref(1);
const selectedAssessmentId = ref('');

const fetchAssessments = async () => {
    try {
        loader.show();
        const { data } = await api.get(`/organizations/${organizationId.value}/assessments`, {
            params: {
                learner_id: learnerId.value,
                page: page.value,
                per_page: 100000,
                status: 1,
            }
        });

        learner.value = data?.data?.learner;
        assessments.value = data?.data?.assessments?.data;
        selectedAssessmentId.value = assessments.value?.[0].id ?? '';
    } catch (error) {
        handleError(error);
    } finally {
        loader.hide();
    }
}

const init = async () => {
    page.value = 1;
    await fetchAssessments();
}

const start = () => {
    if (!selectedAssessmentId.value) return;

    router.push({
        name: 'LearnerWorkpacketGuided', params: {
            organization: organizationId.value,
            learner: learnerId.value,
            assessment: selectedAssessmentId.value
        }
    });
}

watch(route, ({ params }) => {
    organizationId.value = params.organization;
    learnerId.value = params.learner;

    init()
}, { deep: true });

watch(page, () => {
    fetchAssessments();
});

onMounted(async () => {
    await init();
});


const screenWidth = ref(window.innerWidth);
const isMobile = computed(() => screenWidth.value < 1280);
const updateWidth = () => {
    screenWidth.value = window.innerWidth;
};

onMounted(() => {
    window.addEventListener('resize', updateWidth);
});

onUnmounted(() => {
    window.removeEventListener('resize', updateWidth);
});
</script>